// Local storefront catalog. Confirmed terms: PRODUCT_CATALOG.md.
// Editor pricing is compiled independently and checked against this catalog.
window.ZekzekPaperCatalog = {
  minimum: 10,
  tiers: [
    { min: 10, max: 19, discount: 0 },
    { min: 20, max: 49, discount: 15 },
    { min: 50, max: 99, discount: 25 },
    { min: 100, max: null, discount: 30 }
  ],
  products: {
    photocard: { name: { zh: '定制小卡', en: 'Custom Photocards' }, price: 0.30, image: 'zz-photocard-hero-ratio-v2-20260924.webp' },
    postcard: { name: { zh: '定制明信片', en: 'Custom Postcards' }, price: 1.00, image: 'zz-postcard-hero-20260924.webp' }
  }
};
